import styled from 'styled-components';

const StyledImage = styled.img<{ $objectFit?: 'contain' | 'cover' }>`
	user-select: none;
	pointer-events: none;
	object-fit: ${({ $objectFit }) => $objectFit || 'contain'};
`;

const StyledSpinnerContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export { StyledImage, StyledSpinnerContainer };
